import { render } from "./GlobalHeader.vue?vue&type=template&id=36a18118&scoped=true&ts=true"
import script from "./GlobalHeader.vue?vue&type=script&lang=ts"
export * from "./GlobalHeader.vue?vue&type=script&lang=ts"

import "./GlobalHeader.vue?vue&type=style&index=0&id=36a18118&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a18118"]])

export default __exports__